import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../constant";

const getToken = () => {
  const userToken = localStorage.getItem("userToken");
  return userToken ? `Bearer ${userToken}` : "";
};

const dashboardApi = createApi({
  reducerPath: "fetchapi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    mode: "cors",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => ({
        url: `profile`,
        method: "GET",
      }),
    }),
    getDashboardData: builder.query({
      query: (id) => ({
        url: `dashboard/${id}`,
        method: "GET",
      }),
    }),
    getListView: builder.query({
      query: (id) => ({
        url: `mylead/followups?id=${id}`,
        method: "GET",
      }),
    }),
    getNextfollowUp: builder.query({
      query: (id) => ({
        url: `nextfollowup?user_id=${id}`,
        method: "GET",
      }),
    }),
    getCheckinDetail: builder.query({
      query: ({ id, date }) => ({
        url: `attendance/list?userid=${id}&checkinOutdate=${date}`,
        method: "GET",
      }),
    }),
    checkin: builder.mutation({
      query: (checkinDetails) => ({
        url: "attendance/make",
        method: "POST",
        body: checkinDetails,
      }),
    }),
    changePassword: builder.mutation({
      query: (postData) => ({
        url: "change-password",
        method: "POST",
        body: postData,
      }),
    }),
    updateProfile: builder.mutation({
      query: (postData) => ({
        url: "update/profile",
        method: "POST",
        body: postData,
      }),
    }),
  }),
});

export const {
  useGetDashboardDataQuery,
  useGetNextfollowUpQuery,
  useGetListViewQuery,
  useCheckinMutation,
  useGetCheckinDetailQuery,
  useGetUsersQuery,
  useChangePasswordMutation,
  useUpdateProfileMutation,
} = dashboardApi;
export default dashboardApi;
